import { ApiResponse, Clinic } from '@magnetar/admin-api-interfaces'
import { useGet } from './useFetch'
import { useAuth } from './useAuth'

export function useClinicsBySupplierId(supplierId: string | undefined) {
  const { token } = useAuth()
  const { data, error, mutate, isLoading } = useGet<ApiResponse<Clinic[]>>(
    token && supplierId ? `/api/ad-supplier/${supplierId}/clinics` : null,
    undefined,
    token ?? '',
  )

  return {
    clinics: data?.data || [],
    isLoading,
    isError: error,
    mutate,
  }
}
